/* eslint-disable */
import React, {useEffect} from 'react'
import { Layout, Breadcrumb, Radio } from 'antd'
import PageHeader from "components/PageHeader";
import MyFooter from "components/MyFooter";
import { history } from 'redux/store';
import { useTranslation } from 'react-i18next'


const { Header, Footer, Sider, Content } = Layout;



export default function AgreementPrivacy() {
  const { t } = useTranslation()
  const options = [
    { label: `${t('Footer.Terms')}`, value: '1' },
    { label: `${t('Footer.Policy')}`, value: '2' },
  ]
  const onChange = e => {
    console.log(e.target.value);
    if(e.target.value ==='1'){
      history.push('/Term')
    }else{
      history.push('/Privacy')
    }
  }
  return (
    <Layout>
    <Header>
      <PageHeader/>
    </Header>
    <Content style={{ height:'95vh' }}>
    <div className='innerlayout' style={{padding:'50px 5vw',width: '100%', margin:'auto', fontSize:'16px'}}>
        <Breadcrumb separator=">">
        <Breadcrumb.Item>WiAdvance App Market</Breadcrumb.Item>
        <Breadcrumb.Item className='lastchild'>
          {t('FAQ.Legal')}
        </Breadcrumb.Item>
        </Breadcrumb>
      <div className='headtitle'>
      {t('FAQ.Legal')}
      </div>
      <div className='servicedetailradio' style={{marginBottom:'30px'}}>
            <Radio.Group 
              defaultValue="2"
              optionType="button"
              buttonStyle="solid"
              options={options}
              onChange={onChange} 
            />
      </div>
    <div className="agreelayoutPage" style={{width:'100%'}}>
            <div className='title'>
            {t('Footer.Policy')}
            </div>
            <div className="textEditor">
                <p>
                    <span>緯謙科技股份有限公司（以下簡稱“本公司”）非常重視您的個資保護權益，為了讓您（包括但不限於員工、客戶）能夠安心使用本公司提供的緯謙智慧雲市集服務 (以下簡稱“本服務”）以及本公司合作夥伴供應商（以下簡稱“供應商”）通過本服務提供的數位應用(以下簡稱“數位應用”)，特此向您說明本服務的隱私權及資訊安全政策（以下簡稱“本政策”）。請您詳細閱讀本服務的隱私權及資訊安全政策。若有任何意見或疑問，請 E-mail 至appservice@wiadvance.com。</span>
                </p>
                <ol>
                <li style={{color:'#7DB926'}}><strong>適用範圍</strong>
                    <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
                      <li>在您透過下列途徑使用本服務與數位應用時，所涉及的個人資料蒐集、運用與保護均適用本政策。
                      <br/>●	本公司官方網站與本服務網站。
                      <br/>●	當您與本公司聯繫提問問題或客訴時。
                      <br/>●	當您對本服務與數位應用進行評分與評論時。
                      <br/>●	當您參與回覆本公司的調查研究時。
                      <br/>●	當您參與本公司的研討會、論壇、行銷活動與體驗活動時。
                      </li>
                      <li>本服務提供其他公司網站或產品/服務的網路連結，您可經由本服務所提供的連結，點選進入其他網站。但該連結網站或產品/服務可能不適用於本政策，請您必須參考該連結網站或產品/服務中的隱私權政策，本公司不負任何連帶責任。</li>
                      
                    </ol>
                  </li>
                  <li style={{color:'#7DB926'}}><strong>個人資料蒐集之目的</strong>
                    <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
                      <li>當您使用本服務時，本公司可能會蒐集有關您使用本服務以及在服務進行中活動的資訊，作為以下用途使用：
                        <br/>●	提供與交付您所要求的產品與服務。
                        <br/>●	提供您感興趣的產品、服務及行銷活動資訊。
                        <br/>●	改進本公司的產品、服務及行銷方式。
                        <br/>●	用戶數據分析與調查研究，以形成用戶輪廓並規劃開發您所需的產品及服務。
                        <br/>●	服務使用情況統計與分析，並可能會與政府單位、公眾或第三方共享這些統計數據，以展示本服務的整體使用趨勢，但這些統計資訊將不包含可辨識您的身分識別資料。
                        <br/>●	保障本服務與交易安全，本服務使用您的用戶資訊、交易資訊、設備裝置資訊與本服務系統紀錄，執行用戶帳戶、交易與資訊安全風險查核作業，進行用戶身分認證授權、檢測及防範資訊安全事件，並依法採取必要的紀錄、分析與處置措施。
                        <br/>●	行銷；契約、類似契約或其他法律關係事務；個人資料之合法交易事務；消費者、客戶管理與服務；資（通）訓與資料庫管理；網路交易及其他電子商務服務；調查、統計與研究分析；其他經營合於營業登記項目或組織章程所定之業務。
                      </li>
                      <li>當您使用本公司提供的服務時，本服務可能會蒐集您的個人資料。本公司也可能通過來自本公司關聯企業或合作的第三方（包括廣告商與合作夥伴），蒐集到有關您的個人資料與本公司所擁有您的個人資料結合，或與關係企業與合作夥伴共享您的個人資料（請參閱下方“個人資料分享與揭露”章節）。</li>
                    </ol>
                  </li>
                  <li style={{color:'#7DB926'}}><strong>個人資料蒐集、處理及利用方式</strong>
                    <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
                      <li>當您使用本服務所提供之功能服務時，本公司將視該服務功能性質，請您提供必要的個人資料種類如下所列，並同意於該特定目的範圍內蒐集、處理、揭露及利用您的個人資料：
                        <br/>●	註冊會員資訊，包括但不限於：會員帳號（電子郵件）、暱稱、頭像照片、公司資訊（公司中、英文名稱、統一編號、鄧白氏環球編碼、產業別/行業別、公司地址）、聯絡資訊（姓名、職稱、公司電話號碼、行動電話、電子郵件、慣用語言）。
                        <br/>●	為遂行交易行為之交易資訊與訂單資訊，對本服務或數位應用為詢問、訂閱、購買、租賃、參與活動、使用評價等活動。或從事其他交易時，往來之電子郵件、網站留言、回覆客戶之詢問、本公司對會員之詢問、系統自動記錄之軌跡資訊、相關售後服務及其他遂行交易所必要業務資訊。
                        <br/>●	您在本服務進行中活動的資訊，包括但不限於瀏覽和搜尋記錄、使用資訊等。
                        <br/>●	您同意不提供任何錯誤或誤導的資訊，並且您同意在您所提供的資訊有任何錯誤或變更時進行通知。本公司保留單方決定向您要求進一步文件以驗證您所提供的資料之權利。
                      </li>
                      <li>當您使用本公司的服務時，本服務可能會自動（即不通過本服務會員註冊/登入）收集非個人資料（例如：IP地址、您所來自網站之網域名稱、使用網路瀏覽器和作業系統、設備裝置、瀏覽網頁、訪問次數與停留時間）。本服務將使用這些資料，進行網路互動監控、分析趨勢、改進品質與內容，更緊密地研究客戶的需求，以提供良好的客戶體驗。</li>
                      <li>在您使用聯絡客服、問卷調查等互動性行為時，本公司會保留您所提供的個人資料及使用時間等資訊。您於線下同意提供給本公司執行行銷服務相關用途的個人資訊等，本公司將應用於本服務中，以便為您提供精準行銷服務。為提供精確且符合您需求的服務，本公司會將收集的問卷調查內容進行統計分析。分析結果之統計資料分佈或洞察說明，除提供內部研究與供應商外，本公司會視需要公佈但不涉及可識別特定個人之身分識別資料。</li>
                      <li>您知悉並同意若依法律要求、或根據法院命令、或對本公司有管轄權之任何政府或主管機關之要求、或基於善意及誠信原則認有合理之必要性時，本公司得存取、保存及揭露您的帳戶資訊和內容，以：(a) 遵守法律程序；(b) 執行對本公司有管轄權之任何主管機關之要求；(c) 履行本服務之會員條款、本政策或本服務之服務協定；(d) 回應任何實際或可能對本公司不利之主張或其他本服務侵害第三方權利之主張；(d) 回應您的客戶服務請求；或者 (e) 保護本公司、其使用者及/或公眾之權利、財產或人身安全。</li>
                      <li>由於本公司將會/可能蒐集、使用、揭露或處理您個人資料的目的取決於當時的情況，該目的可能未出現在上述項目中。不過，我們會在取得您同意的當時，向您告知該其他目的，除非相關法律法規允許我們在未取得您同意的情況下即可處理適用的資料。</li>
                      
                    </ol>
                  </li>
                  <li style={{color:'#7DB926'}}><strong>個人資料分享與揭露</strong>
                    <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
                      <li>為提供您所要求的產品與服務，本公司於特定情形下，可能會向其他個人、團體或企業，分享您的個人資料，本條款所稱特定情形包括但不限於：
                        <br/>●	為提供您感興趣的產品、服務與活動，將您的個人資訊與合作夥伴分享
                        <br/>●	本服務可能將您的個人資料與本服務的供應商分享，作為本公司營業目的之用
                        <br/>●	將您的個人資料與本公司、本公司關聯企業分享，作為本公司營業目的之用
                        <br/>●	社群互動交流與分享，當您使用第三方社群服務、部落格服務或本公司提供的社群互動交流服務時，您的使用者名稱以及您發佈的部落格、貼文、評論與見證，作為本公司營業目的之用，所有使用本服務的人都可看到您的使用者名稱與您發佈的任何評論與內容
                        <br/>●	依您的興趣導向之廣告投放，我們可能會有來自第三方或使用如cookie或網路信標等技術，在本公司提供的服務上識別您的身分並提供您可能有興趣的產品、服務與活動投放廣告，或於其他網路或其他服務見到本公司的相關廣告
                        <br/>●	當您在使用本公司提供的服務時，違反會員條款、本服務之服務協定與服務增補協定，或可能損害或妨礙本公司與其他使用者權益或導致任何人遭受損害時，經本公司系統管理單位研析揭露您的個人資料是為了辨識、聯絡、採取法律行動或對訴訟請求防禦行動之必要應對措施
                        <br/>●	依法律明文規定、執法機關與資料保護主管機關之需求分享，為了遵守適用法律下的法律義務，或對執法機關之搜查令、法院命令或傳票等司法程序作出回應，本公司將分享您的個人資料
                        <br/>●	跨國傳輸，您的個人資訊可能會被傳輸至國外之數據儲存設備或伺服器，或傳輸到位於其他國家之第三方數據儲存設備或伺服器，以便本公司依本政策蒐集、處理與利用您的個人資料，並為您提供服務
                      </li>
       
                    </ol>
                  </li>
                  <li style={{color:'#7DB926'}}><strong>Cookie運用政策</strong>
                    <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
                    <li>為了便利本服務會員使用，當您使用本公司網站服務時，本公司可能在您的設備上設定與存取Cookie。您可以透過設定您的上網設備，決定是否允許Cookie技術的使用，若您選擇關閉Cookie時，可能會造成您使用本公司服務時不便利或部分功能限制。</li>
                    <li>依據以下目的及情況，本服務會在本政策原則之下，在您瀏覽器中寫入並讀取Cookie：
                    <br/>●	為提供更好的個人化服務，以及方便您參與個人化的互動活動。Cookie在您註冊或登入時建立，並在您登出時修改。
                    <br/>●	為統計瀏覽人數及分析瀏覽模式，以了解網頁瀏覽的情況，做為本服務改善服務的參考。
                    </li>

       
                    </ol>
                  </li>
                  <li style={{color:'#7DB926'}}><strong>資訊安全與保護</strong>
                    <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
                    本服務的雲端服務主機均設有防火牆、防毒系統等各項資訊安全設備及必要的安全保護措施，來防止您的個人資料被竊取、竄改、毀損、滅失或洩漏。相關的執行業務人員皆有簽訂保密合約，如有違反保密義務者，將會受到相關法律約束與處分。本公司會善盡保護您的個人資料之責任，您仍須注意並妥善保密您的個人資料與會員帳號密碼，請勿將您的個人資料與會員帳號密碼提供給任何人。並在您使用本服務後，請記得要「登出」您的個人帳戶。並避免與他人共享電腦或使用公共電腦，若透過瀏覽器使用服務者，請務必關閉瀏覽器視窗
                    </ol>
                  </li>
                  <li style={{color:'#7DB926'}}><strong>隱私權政策之修改</strong>
                    <ol style={{color:'rgba(0, 0, 0, 0.85)'}}>
                    本政策將因應本公司營運需求與法律規定隨時進行修改，修改後的條款將公佈在本服務的網站上，使您得知本公司個資蒐集、處理、利用與揭露的情形。
                    </ol>
                  </li>
                  本政策最新版本日期為2022年6月。
                </ol>
            </div>
        </div>
    </div>
    <MyFooter />
    </Content>

    </Layout>
  )
}
